<script>
    import Fa from "svelte-fa";
    import {faCertificate, faCreditCard} from "@fortawesome/free-solid-svg-icons";

    export let showIcon = true;
    export let token;
    export let emptyIcon = faCreditCard;
    export let emptyLabel = '';

    $: icon = token ? (token.type === 'HW' ? faCreditCard : faCertificate) : emptyIcon;
    $: label = token ? (token.customName ? token.subjectCommonName + ' | ' + token.customName : token.subjectCommonName) : emptyLabel;
</script>

{#if showIcon}
    <span class="token-icon"><Fa {icon} /></span>
{/if}
<span class="token-label">{label}</span>

<style>
    .token-icon {
        color: var(--brak-dark-blue);
        margin-right: 0.3em;
    }

    .token-label {
        font-weight: bold;
    }
</style>